/**
 * Create Instacart shopping list page for meal plan
 */
export const createInstacartShoppingList = async (
  mealPlanId: string,
  userToken: string
): Promise<{
  success: boolean;
  instacartUrl: string;
  expiresAt: string;
  cached?: boolean;
}> => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/api/meals/plans/${mealPlanId}/instacart`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `Request failed: ${response.status}`);
  }

  return await response.json();
};

/**
 * Create Instacart recipe page for individual recipe
 */
export const createInstacartRecipePage = async (
  userId: string,
  recipeId: string,
  userToken?: string
): Promise<{
  success: boolean;
  instacartUrl: string;
  expiresAt: string;
  cached?: boolean;
}> => {
  const headers: HeadersInit = {
    "Content-Type": "application/json",
  };

  if (userToken) {
    headers.Authorization = `Bearer ${userToken}`;
  }

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/api/u/${userId}/recipes/${recipeId}/instacart`,
    {
      method: "POST",
      headers,
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `Request failed: ${response.status}`);
  }

  return await response.json();
};

/**
 * Create Instacart recipe page for scaled recipe in meal plan assignment
 */
export const createInstacartRecipePageForAssignment = async (
  mealPlanId: string,
  assignmentId: string,
  userToken: string
): Promise<{
  success: boolean;
  instacartUrl: string;
  expiresAt: string;
  cached?: boolean;
}> => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/api/meals/plans/${mealPlanId}/assignments/${assignmentId}/instacart`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `Request failed: ${response.status}`);
  }

  return await response.json();
};